// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-container {
    max-width: 800px;
    margin: 40px auto;
    padding: 0 20px;
    font-family: 'Inter', sans-serif;
}

.wallet-header {
    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
    border-radius: 20px;
    padding: 40px;
    color: #333;
    text-align: center;
    box-shadow: 0 10px 30px rgba(255, 215, 0, 0.3);
    margin-bottom: 40px;
    position: relative;
    overflow: hidden;
}

.wallet-header h1 {
    margin: 0 0 20px 0;
    font-size: 24px;
    font-weight: 600;
    opacity: 0.9;
}

.balance-card {
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 15px;
    padding: 30px;
    display: inline-block;
    min-width: 300px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.balance-label {
    display: block;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #666;
    margin-bottom: 10px;
}

.balance-value {
    font-size: 48px;
    font-weight: 800;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 5px;
}

.balance-value i {
    color: #FFD700;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.balance-unit {
    font-size: 14px;
    color: #888;
    font-weight: 500;
}

.btn-upload-receipt {
    margin-top: 30px;
    background: #333;
    color: #FFD700;
    border: none;
    padding: 15px 30px;
    border-radius: 50px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

.btn-upload-receipt:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.transactions-section h2 {
    font-size: 20px;
    color: #333;
    margin-bottom: 20px;
    border-bottom: 2px solid #eee;
    padding-bottom: 10px;
}

.transactions-list {
    background: white;
    border-radius: 15px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.transaction-item {
    display: flex;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.2s;
}

.transaction-item:last-child {
    border-bottom: none;
}

.transaction-item:hover {
    background: #f9f9f9;
}

.tx-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    font-size: 18px;
}

.positive .tx-icon {
    background: #e6f7e6;
    color: #2ecc71;
}

.negative .tx-icon {
    background: #ffe6e6;
    color: #e74c3c;
}

.tx-details {
    flex: 1 1;
}

.tx-desc {
    display: block;
    font-weight: 600;
    color: #333;
    margin-bottom: 4px;
}

.tx-date {
    font-size: 12px;
    color: #999;
}

.tx-amount {
    font-weight: 700;
    font-size: 16px;
}

.positive .tx-amount {
    color: #2ecc71;
}

.negative .tx-amount {
    color: #e74c3c;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(5px);
}

.modal-content {
    background: white;
    padding: 30px;
    border-radius: 20px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
}

.modal-content h2 {
    margin-top: 0;
    color: #333;
    text-align: center;
    margin-bottom: 25px;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #555;
}

.form-group input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.2s;
}

.form-group input:focus {
    border-color: #FFD700;
    outline: none;
}

.modal-actions {
    display: flex;
    gap: 15px;
    margin-top: 30px;
}

.modal-actions button {
    flex: 1 1;
    padding: 12px;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    font-size: 16px;
}

.btn-cancel {
    background: #f0f0f0;
    color: #666;
}

.btn-submit {
    background: #FFD700;
    color: #333;
}

.balance-value i {
    color: #FFD700;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.balance-unit {
    font-size: 14px;
    color: #888;
    font-weight: 500;
}

.btn-upload-receipt {
    margin-top: 30px;
    background: #333;
    color: #FFD700;
    border: none;
    padding: 15px 30px;
    border-radius: 50px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

.btn-upload-receipt:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.transactions-section h2 {
    font-size: 20px;
    color: #333;
    margin-bottom: 20px;
    border-bottom: 2px solid #eee;
    padding-bottom: 10px;
}

.transactions-list {
    background: white;
    border-radius: 15px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.transaction-item {
    display: flex;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.2s;
}

.transaction-item:last-child {
    border-bottom: none;
}

.transaction-item:hover {
    background: #f9f9f9;
}

.tx-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    font-size: 18px;
}

.positive .tx-icon {
    background: #e6f7e6;
    color: #2ecc71;
}

.negative .tx-icon {
    background: #ffe6e6;
    color: #e74c3c;
}

.tx-details {
    flex: 1 1;
}

.tx-desc {
    display: block;
    font-weight: 600;
    color: #333;
    margin-bottom: 4px;
}

.tx-date {
    font-size: 12px;
    color: #999;
}

.tx-amount {
    font-weight: 700;
    font-size: 16px;
}

.positive .tx-amount {
    color: #2ecc71;
}

.negative .tx-amount {
    color: #e74c3c;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(5px);
}

.modal-content {
    background: white;
    padding: 30px;
    border-radius: 20px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
}

.modal-content h2 {
    margin-top: 0;
    color: #333;
    text-align: center;
    margin-bottom: 25px;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #555;
}

.form-group input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.2s;
}

.form-group input:focus {
    border-color: #FFD700;
    outline: none;
}

.modal-actions {
    display: flex;
    gap: 15px;
    margin-top: 30px;
}

.modal-actions button {
    flex: 1 1;
    padding: 12px;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    font-size: 16px;
}

.btn-cancel {
    background: #f0f0f0;
    color: #666;
}

.btn-submit {
    background: #FFD700;
    color: #333;
}

.btn-submit:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.success-msg {
    color: #2ecc71;
    font-size: 14px;
    margin-top: 5px;
}

/* Tabs */
.wallet-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 30px;
}

.btn-tab {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #333;
    padding: 10px 25px;
    border-radius: 25px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-tab:hover {
    background: rgba(255, 255, 255, 0.4);
}

.btn-tab.active {
    background: #333;
    color: #FFD700;
    border-color: #333;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

/* Rewards Grid */
.rewards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
}

.reward-card {
    background: white;
    border-radius: 15px;
    padding: 25px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    text-align: center;
    transition: transform 0.2s;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.reward-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.reward-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: white;
    margin-bottom: 15px;
}

.reward-info h3 {
    margin: 0 0 10px 0;
    font-size: 18px;
    color: #333;
}

.reward-info p {
    color: #666;
    font-size: 14px;
    margin-bottom: 15px;
    line-height: 1.4;
}

.reward-cost {
    font-weight: 700;
    color: #333;
    font-size: 18px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.reward-cost i {
    color: #FFD700;
}

.btn-redeem {
    background: #2ecc71;
    color: white;
    border: none;
    padding: 12px 30px;
    border-radius: 25px;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    transition: background 0.2s;
}

.btn-redeem:hover {
    background: #27ae60;
}

.btn-redeem:disabled {
    background: #ccc;
    cursor: not-allowed;
}

/* Redemption Modal */
.redeem-summary {
    background: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    text-align: center;
    margin-bottom: 20px;
}

.redeem-summary h3 {
    margin: 5px 0;
    color: #333;
}

.redeem-summary .cost {
    color: #666;
    margin-top: 5px;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.section-header h2 {
    margin-bottom: 0;
    border-bottom: none;
}

.section-header .btn-upload-receipt {
    margin-top: 0;
    padding: 10px 20px;
    font-size: 14px;
}

/* ==========================================
   Mercado Íntimo Dark Mode Overrides
   ========================================== */
.wallet-header {
    background: linear-gradient(135deg, #18181b 0%, #09090b 100%) !important;
    border: 1px solid var(--border-color) !important;
    box-shadow: var(--shadow-md) !important;
    color: var(--text-primary) !important;
}

.balance-card {
    background: rgba(24, 24, 27, 0.8) !important;
    border: 1px solid var(--border-color) !important;
    color: var(--text-primary) !important;
}

.balance-label {
    color: var(--text-secondary) !important;
}

.balance-value {
    color: var(--text-primary) !important;
}

.balance-value i {
    color: var(--accent-color) !important;
}

.balance-unit {
    color: var(--text-muted) !important;
}

.btn-upload-receipt {
    background: var(--primary-color) !important;
    color: #fff !important;
}

.btn-upload-receipt:hover {
    background: var(--primary-hover) !important;
}

.transactions-section h2, .rewards-section h2 {
    color: var(--text-primary) !important;
    border-bottom-color: var(--border-color) !important;
}

.transactions-list {
    background: var(--background-white) !important;
    border: 1px solid var(--border-color) !important;
}

.transaction-item {
    border-bottom-color: var(--border-color) !important;
}

.transaction-item:hover {
    background: var(--background-light) !important;
}

.tx-desc {
    color: var(--text-primary) !important;
}

.tx-date {
    color: var(--text-muted) !important;
}

.positive .tx-amount {
    color: var(--primary-color) !important; /* Rosa Choque em transações positivas */
}

.positive .tx-icon {
    background: var(--primary-light) !important;
    color: var(--primary-color) !important;
}

.negative .tx-icon {
    background: rgba(239, 68, 68, 0.1) !important;
    color: var(--danger-color) !important;
}

.negative .tx-amount {
    color: var(--danger-color) !important;
}

/* Modal Dark Mode */
.modal-content {
    background: var(--background-white) !important;
    border: 1px solid var(--border-color) !important;
    color: var(--text-primary) !important;
}

.modal-content h2 {
    color: var(--text-primary) !important;
}

.form-group label {
    color: var(--text-secondary) !important;
}

.form-group input {
    background: var(--background-light) !important;
    border-color: var(--border-color) !important;
    color: var(--text-primary) !important;
}

.form-group input:focus {
    border-color: var(--primary-color) !important;
}

.btn-cancel {
    background: var(--background-light) !important;
    color: var(--text-secondary) !important;
    border: 1px solid var(--border-color) !important;
}

.btn-submit {
    background: var(--primary-color) !important;
    color: #fff !important;
}

.btn-submit:hover {
    background: var(--primary-hover) !important;
}

.btn-tab {
    background: rgba(255, 255, 255, 0.05) !important;
    border-color: var(--border-color) !important;
    color: var(--text-secondary) !important;
}

.btn-tab:hover {
    background: rgba(255, 255, 255, 0.1) !important;
    color: var(--text-primary) !important;
}

.btn-tab.active {
    background: var(--primary-color) !important;
    color: #fff !important;
    border-color: var(--primary-color) !important;
}

.reward-card {
    background: var(--background-white) !important;
    border: 1px solid var(--border-color) !important;
}

.reward-info h3 {
    color: var(--text-primary) !important;
}

.reward-info p {
    color: var(--text-secondary) !important;
}

.reward-cost {
    color: var(--text-primary) !important;
}

.reward-cost i {
    color: var(--accent-color) !important;
}

.btn-redeem {
    background: var(--primary-color) !important;
    color: #fff !important;
}

.btn-redeem:hover {
    background: var(--primary-hover) !important;
}

.btn-redeem:disabled {
    background: var(--background-light) !important;
    color: var(--text-muted) !important;
    border: 1px solid var(--border-color) !important;
}

.redeem-summary {
    background: var(--background-light) !important;
    border: 1px solid var(--border-color) !important;
}

.redeem-summary h3 {
    color: var(--text-primary) !important;
}

.redeem-summary .cost {
    color: var(--text-secondary) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Wallet.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,6DAA6D;IAC7D,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,8CAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2CAA2C;IAC3C,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2CAA2C;IAC3C,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;+CAE+C;AAC/C;IACI,wEAAwE;IACxE,gDAAgD;IAChD,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA;IACI,4CAA4C;IAC5C,gDAAgD;IAChD,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,mDAAmD;AACvD;;AAEA;IACI,8CAA8C;IAC9C,gDAAgD;AACpD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sCAAsC,EAAE,wCAAwC;AACpF;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,6CAA6C;IAC7C,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA,oBAAoB;AACpB;IACI,8CAA8C;IAC9C,gDAAgD;IAChD,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,8CAA8C;IAC9C,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,8CAA8C;IAC9C,uCAAuC;IACvC,gDAAgD;AACpD;;AAEA;IACI,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gDAAgD;IAChD,4CAA4C;IAC5C,uCAAuC;AAC3C;;AAEA;IACI,+CAA+C;IAC/C,qCAAqC;AACzC;;AAEA;IACI,2CAA2C;IAC3C,sBAAsB;IACtB,6CAA6C;AACjD;;AAEA;IACI,8CAA8C;IAC9C,gDAAgD;AACpD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,8CAA8C;IAC9C,mCAAmC;IACnC,gDAAgD;AACpD;;AAEA;IACI,8CAA8C;IAC9C,gDAAgD;AACpD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;AAC3C","sourcesContent":[".wallet-container {\r\n    max-width: 800px;\r\n    margin: 40px auto;\r\n    padding: 0 20px;\r\n    font-family: 'Inter', sans-serif;\r\n}\r\n\r\n.wallet-header {\r\n    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);\r\n    border-radius: 20px;\r\n    padding: 40px;\r\n    color: #333;\r\n    text-align: center;\r\n    box-shadow: 0 10px 30px rgba(255, 215, 0, 0.3);\r\n    margin-bottom: 40px;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.wallet-header h1 {\r\n    margin: 0 0 20px 0;\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n    opacity: 0.9;\r\n}\r\n\r\n.balance-card {\r\n    background: rgba(255, 255, 255, 0.9);\r\n    backdrop-filter: blur(10px);\r\n    border-radius: 15px;\r\n    padding: 30px;\r\n    display: inline-block;\r\n    min-width: 300px;\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.balance-label {\r\n    display: block;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1px;\r\n    color: #666;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.balance-value {\r\n    font-size: 48px;\r\n    font-weight: 800;\r\n    color: #333;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.balance-value i {\r\n    color: #FFD700;\r\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.balance-unit {\r\n    font-size: 14px;\r\n    color: #888;\r\n    font-weight: 500;\r\n}\r\n\r\n.btn-upload-receipt {\r\n    margin-top: 30px;\r\n    background: #333;\r\n    color: #FFD700;\r\n    border: none;\r\n    padding: 15px 30px;\r\n    border-radius: 50px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: transform 0.2s, box-shadow 0.2s;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.btn-upload-receipt:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.transactions-section h2 {\r\n    font-size: 20px;\r\n    color: #333;\r\n    margin-bottom: 20px;\r\n    border-bottom: 2px solid #eee;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.transactions-list {\r\n    background: white;\r\n    border-radius: 15px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n    overflow: hidden;\r\n}\r\n\r\n.transaction-item {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 20px;\r\n    border-bottom: 1px solid #f0f0f0;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.transaction-item:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.transaction-item:hover {\r\n    background: #f9f9f9;\r\n}\r\n\r\n.tx-icon {\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-right: 15px;\r\n    font-size: 18px;\r\n}\r\n\r\n.positive .tx-icon {\r\n    background: #e6f7e6;\r\n    color: #2ecc71;\r\n}\r\n\r\n.negative .tx-icon {\r\n    background: #ffe6e6;\r\n    color: #e74c3c;\r\n}\r\n\r\n.tx-details {\r\n    flex: 1;\r\n}\r\n\r\n.tx-desc {\r\n    display: block;\r\n    font-weight: 600;\r\n    color: #333;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.tx-date {\r\n    font-size: 12px;\r\n    color: #999;\r\n}\r\n\r\n.tx-amount {\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n}\r\n\r\n.positive .tx-amount {\r\n    color: #2ecc71;\r\n}\r\n\r\n.negative .tx-amount {\r\n    color: #e74c3c;\r\n}\r\n\r\n/* Modal Styles */\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n    backdrop-filter: blur(5px);\r\n}\r\n\r\n.modal-content {\r\n    background: white;\r\n    padding: 30px;\r\n    border-radius: 20px;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.modal-content h2 {\r\n    margin-top: 0;\r\n    color: #333;\r\n    text-align: center;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-group label {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    font-weight: 500;\r\n    color: #555;\r\n}\r\n\r\n.form-group input {\r\n    width: 100%;\r\n    padding: 12px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px;\r\n    font-size: 16px;\r\n    transition: border-color 0.2s;\r\n}\r\n\r\n.form-group input:focus {\r\n    border-color: #FFD700;\r\n    outline: none;\r\n}\r\n\r\n.modal-actions {\r\n    display: flex;\r\n    gap: 15px;\r\n    margin-top: 30px;\r\n}\r\n\r\n.modal-actions button {\r\n    flex: 1;\r\n    padding: 12px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n}\r\n\r\n.btn-cancel {\r\n    background: #f0f0f0;\r\n    color: #666;\r\n}\r\n\r\n.btn-submit {\r\n    background: #FFD700;\r\n    color: #333;\r\n}\r\n\r\n.balance-value i {\r\n    color: #FFD700;\r\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.balance-unit {\r\n    font-size: 14px;\r\n    color: #888;\r\n    font-weight: 500;\r\n}\r\n\r\n.btn-upload-receipt {\r\n    margin-top: 30px;\r\n    background: #333;\r\n    color: #FFD700;\r\n    border: none;\r\n    padding: 15px 30px;\r\n    border-radius: 50px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: transform 0.2s, box-shadow 0.2s;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.btn-upload-receipt:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.transactions-section h2 {\r\n    font-size: 20px;\r\n    color: #333;\r\n    margin-bottom: 20px;\r\n    border-bottom: 2px solid #eee;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.transactions-list {\r\n    background: white;\r\n    border-radius: 15px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n    overflow: hidden;\r\n}\r\n\r\n.transaction-item {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 20px;\r\n    border-bottom: 1px solid #f0f0f0;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.transaction-item:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.transaction-item:hover {\r\n    background: #f9f9f9;\r\n}\r\n\r\n.tx-icon {\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-right: 15px;\r\n    font-size: 18px;\r\n}\r\n\r\n.positive .tx-icon {\r\n    background: #e6f7e6;\r\n    color: #2ecc71;\r\n}\r\n\r\n.negative .tx-icon {\r\n    background: #ffe6e6;\r\n    color: #e74c3c;\r\n}\r\n\r\n.tx-details {\r\n    flex: 1;\r\n}\r\n\r\n.tx-desc {\r\n    display: block;\r\n    font-weight: 600;\r\n    color: #333;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.tx-date {\r\n    font-size: 12px;\r\n    color: #999;\r\n}\r\n\r\n.tx-amount {\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n}\r\n\r\n.positive .tx-amount {\r\n    color: #2ecc71;\r\n}\r\n\r\n.negative .tx-amount {\r\n    color: #e74c3c;\r\n}\r\n\r\n/* Modal Styles */\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n    backdrop-filter: blur(5px);\r\n}\r\n\r\n.modal-content {\r\n    background: white;\r\n    padding: 30px;\r\n    border-radius: 20px;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.modal-content h2 {\r\n    margin-top: 0;\r\n    color: #333;\r\n    text-align: center;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-group label {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    font-weight: 500;\r\n    color: #555;\r\n}\r\n\r\n.form-group input {\r\n    width: 100%;\r\n    padding: 12px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px;\r\n    font-size: 16px;\r\n    transition: border-color 0.2s;\r\n}\r\n\r\n.form-group input:focus {\r\n    border-color: #FFD700;\r\n    outline: none;\r\n}\r\n\r\n.modal-actions {\r\n    display: flex;\r\n    gap: 15px;\r\n    margin-top: 30px;\r\n}\r\n\r\n.modal-actions button {\r\n    flex: 1;\r\n    padding: 12px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n}\r\n\r\n.btn-cancel {\r\n    background: #f0f0f0;\r\n    color: #666;\r\n}\r\n\r\n.btn-submit {\r\n    background: #FFD700;\r\n    color: #333;\r\n}\r\n\r\n.btn-submit:disabled {\r\n    opacity: 0.7;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.success-msg {\r\n    color: #2ecc71;\r\n    font-size: 14px;\r\n    margin-top: 5px;\r\n}\r\n\r\n/* Tabs */\r\n.wallet-actions {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 15px;\r\n    margin-top: 30px;\r\n}\r\n\r\n.btn-tab {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border: 1px solid rgba(255, 255, 255, 0.3);\r\n    color: #333;\r\n    padding: 10px 25px;\r\n    border-radius: 25px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.btn-tab:hover {\r\n    background: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\n.btn-tab.active {\r\n    background: #333;\r\n    color: #FFD700;\r\n    border-color: #333;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Rewards Grid */\r\n.rewards-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\r\n    gap: 20px;\r\n}\r\n\r\n.reward-card {\r\n    background: white;\r\n    border-radius: 15px;\r\n    padding: 25px;\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\r\n    text-align: center;\r\n    transition: transform 0.2s;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.reward-card:hover {\r\n    transform: translateY(-5px);\r\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.reward-icon {\r\n    width: 60px;\r\n    height: 60px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 24px;\r\n    color: white;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.reward-info h3 {\r\n    margin: 0 0 10px 0;\r\n    font-size: 18px;\r\n    color: #333;\r\n}\r\n\r\n.reward-info p {\r\n    color: #666;\r\n    font-size: 14px;\r\n    margin-bottom: 15px;\r\n    line-height: 1.4;\r\n}\r\n\r\n.reward-cost {\r\n    font-weight: 700;\r\n    color: #333;\r\n    font-size: 18px;\r\n    margin-bottom: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n}\r\n\r\n.reward-cost i {\r\n    color: #FFD700;\r\n}\r\n\r\n.btn-redeem {\r\n    background: #2ecc71;\r\n    color: white;\r\n    border: none;\r\n    padding: 12px 30px;\r\n    border-radius: 25px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.btn-redeem:hover {\r\n    background: #27ae60;\r\n}\r\n\r\n.btn-redeem:disabled {\r\n    background: #ccc;\r\n    cursor: not-allowed;\r\n}\r\n\r\n/* Redemption Modal */\r\n.redeem-summary {\r\n    background: #f9f9f9;\r\n    padding: 15px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.redeem-summary h3 {\r\n    margin: 5px 0;\r\n    color: #333;\r\n}\r\n\r\n.redeem-summary .cost {\r\n    color: #666;\r\n    margin-top: 5px;\r\n}\r\n\r\n.section-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.section-header h2 {\r\n    margin-bottom: 0;\r\n    border-bottom: none;\r\n}\r\n\r\n.section-header .btn-upload-receipt {\r\n    margin-top: 0;\r\n    padding: 10px 20px;\r\n    font-size: 14px;\r\n}\r\n\r\n/* ==========================================\r\n   Mercado Íntimo Dark Mode Overrides\r\n   ========================================== */\r\n.wallet-header {\r\n    background: linear-gradient(135deg, #18181b 0%, #09090b 100%) !important;\r\n    border: 1px solid var(--border-color) !important;\r\n    box-shadow: var(--shadow-md) !important;\r\n    color: var(--text-primary) !important;\r\n}\r\n\r\n.balance-card {\r\n    background: rgba(24, 24, 27, 0.8) !important;\r\n    border: 1px solid var(--border-color) !important;\r\n    color: var(--text-primary) !important;\r\n}\r\n\r\n.balance-label {\r\n    color: var(--text-secondary) !important;\r\n}\r\n\r\n.balance-value {\r\n    color: var(--text-primary) !important;\r\n}\r\n\r\n.balance-value i {\r\n    color: var(--accent-color) !important;\r\n}\r\n\r\n.balance-unit {\r\n    color: var(--text-muted) !important;\r\n}\r\n\r\n.btn-upload-receipt {\r\n    background: var(--primary-color) !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.btn-upload-receipt:hover {\r\n    background: var(--primary-hover) !important;\r\n}\r\n\r\n.transactions-section h2, .rewards-section h2 {\r\n    color: var(--text-primary) !important;\r\n    border-bottom-color: var(--border-color) !important;\r\n}\r\n\r\n.transactions-list {\r\n    background: var(--background-white) !important;\r\n    border: 1px solid var(--border-color) !important;\r\n}\r\n\r\n.transaction-item {\r\n    border-bottom-color: var(--border-color) !important;\r\n}\r\n\r\n.transaction-item:hover {\r\n    background: var(--background-light) !important;\r\n}\r\n\r\n.tx-desc {\r\n    color: var(--text-primary) !important;\r\n}\r\n\r\n.tx-date {\r\n    color: var(--text-muted) !important;\r\n}\r\n\r\n.positive .tx-amount {\r\n    color: var(--primary-color) !important; /* Rosa Choque em transações positivas */\r\n}\r\n\r\n.positive .tx-icon {\r\n    background: var(--primary-light) !important;\r\n    color: var(--primary-color) !important;\r\n}\r\n\r\n.negative .tx-icon {\r\n    background: rgba(239, 68, 68, 0.1) !important;\r\n    color: var(--danger-color) !important;\r\n}\r\n\r\n.negative .tx-amount {\r\n    color: var(--danger-color) !important;\r\n}\r\n\r\n/* Modal Dark Mode */\r\n.modal-content {\r\n    background: var(--background-white) !important;\r\n    border: 1px solid var(--border-color) !important;\r\n    color: var(--text-primary) !important;\r\n}\r\n\r\n.modal-content h2 {\r\n    color: var(--text-primary) !important;\r\n}\r\n\r\n.form-group label {\r\n    color: var(--text-secondary) !important;\r\n}\r\n\r\n.form-group input {\r\n    background: var(--background-light) !important;\r\n    border-color: var(--border-color) !important;\r\n    color: var(--text-primary) !important;\r\n}\r\n\r\n.form-group input:focus {\r\n    border-color: var(--primary-color) !important;\r\n}\r\n\r\n.btn-cancel {\r\n    background: var(--background-light) !important;\r\n    color: var(--text-secondary) !important;\r\n    border: 1px solid var(--border-color) !important;\r\n}\r\n\r\n.btn-submit {\r\n    background: var(--primary-color) !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.btn-submit:hover {\r\n    background: var(--primary-hover) !important;\r\n}\r\n\r\n.btn-tab {\r\n    background: rgba(255, 255, 255, 0.05) !important;\r\n    border-color: var(--border-color) !important;\r\n    color: var(--text-secondary) !important;\r\n}\r\n\r\n.btn-tab:hover {\r\n    background: rgba(255, 255, 255, 0.1) !important;\r\n    color: var(--text-primary) !important;\r\n}\r\n\r\n.btn-tab.active {\r\n    background: var(--primary-color) !important;\r\n    color: #fff !important;\r\n    border-color: var(--primary-color) !important;\r\n}\r\n\r\n.reward-card {\r\n    background: var(--background-white) !important;\r\n    border: 1px solid var(--border-color) !important;\r\n}\r\n\r\n.reward-info h3 {\r\n    color: var(--text-primary) !important;\r\n}\r\n\r\n.reward-info p {\r\n    color: var(--text-secondary) !important;\r\n}\r\n\r\n.reward-cost {\r\n    color: var(--text-primary) !important;\r\n}\r\n\r\n.reward-cost i {\r\n    color: var(--accent-color) !important;\r\n}\r\n\r\n.btn-redeem {\r\n    background: var(--primary-color) !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.btn-redeem:hover {\r\n    background: var(--primary-hover) !important;\r\n}\r\n\r\n.btn-redeem:disabled {\r\n    background: var(--background-light) !important;\r\n    color: var(--text-muted) !important;\r\n    border: 1px solid var(--border-color) !important;\r\n}\r\n\r\n.redeem-summary {\r\n    background: var(--background-light) !important;\r\n    border: 1px solid var(--border-color) !important;\r\n}\r\n\r\n.redeem-summary h3 {\r\n    color: var(--text-primary) !important;\r\n}\r\n\r\n.redeem-summary .cost {\r\n    color: var(--text-secondary) !important;\r\n}\r"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
